import { render, staticRenderFns } from "./config-anime.vue?vue&type=template&id=e9cefe1c&"
import script from "./config-anime.vue?vue&type=script&lang=js&"
export * from "./config-anime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports